import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, CTA, SITE } from "@/site/content";
import { track } from "@/site/analytics";
import Mark from "./Mark";

export function Brand() {
  return (
    <Link to="/" className="brand" aria-label="Postern home" data-testid="brand-link">
      <Mark size={26} />
      <span>Postern</span>
    </Link>
  );
}

export default function Nav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  // The hero no longer has its own CTA button, so the nav's "Start a
  // pilot" is the only one above the fold -- always visible.
  const showCta = true;
  const isHash = (to) => to.startsWith("/#");
  const linkEl = (item) =>
    isHash(item.to) ? (
      <a key={item.to} href={item.to} onClick={() => setOpen(false)} className={loc.pathname === "/" && loc.hash === item.to.slice(1) ? "active" : ""}>{item.label}</a>
    ) : (
      <NavLink key={item.to} to={item.to} onClick={() => setOpen(false)}>{item.label}</NavLink>
    );
  return (
    <header className="nav" data-testid="site-nav">
      <div className="wrap nav__in">
        <Brand />
        <nav className="nav__links" aria-label="Primary">{NAV.map(linkEl)}</nav>
        <div className="nav__cta">
          {SITE.appUrl && <a className="btn btn--ghost btn--sm" href={SITE.appUrl} data-testid="nav-login" onClick={() => track("login_click", { where: "nav" })}>Log in</a>}
          <Link className={`btn btn--primary btn--sm nav-cta ${showCta ? "nav-cta--in" : "nav-cta--out"}`} to="/pilot" data-testid="nav-cta" aria-hidden={!showCta} tabIndex={showCta ? 0 : -1} onClick={() => track("cta_click", { where: "nav" })}>{CTA.primary}</Link>
          <button className="nav__burger" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} onClick={() => setOpen((o) => !o)} data-testid="nav-burger">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="nav__mobile" data-testid="nav-mobile">
          {NAV.map(linkEl)}
          {SITE.appUrl && <a href={SITE.appUrl}>Log in</a>}
        </div>
      )}
    </header>
  );
}
